"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function TooltipWrapper(props) {
  var title = props.title,
      flipTooltipDisplay = props.flipTooltipDisplay,
      isHeaderCentered = props.isHeaderCentered,
      children = props.children;
  var headerCN = (0, _classnames.default)('py-3 px-4 border-b text-gray-700 text-xs tracking-wide', {
    'text-center': isHeaderCentered
  });
  var tooltipStyle = flipTooltipDisplay ? {
    transform: 'translateX(-110%)'
  } : {};
  return _react.default.createElement("div", {
    className: "bg-white shadow-md border rounded",
    style: tooltipStyle
  }, _react.default.createElement("div", {
    className: headerCN
  }, title), children);
}

TooltipWrapper.propTypes = {
  title: _propTypes.default.string.isRequired,
  flipTooltipDisplay: _propTypes.default.bool,
  isHeaderCentered: _propTypes.default.bool,
  children: _propTypes.default.node
};
TooltipWrapper.defaultProps = {
  flipTooltipDisplay: false,
  isHeaderCentered: false
};

var _default = _react.default.memo(TooltipWrapper);

exports.default = _default;